/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
import { Provider, TransactionRequest } from "@ethersproject/providers"
import {
    Signer,
    BigNumberish,
    Contract,
    ContractFactory,
    Overrides
} from "ethers"

import type { Enoji } from "./Enoji"

export class Enoji__factory extends ContractFactory {
    constructor(signer?: Signer) {
        super(_abi, _bytecode, signer)
    }

    deploy(
        _n: string,
        _priceInWei: BigNumberish,
        _dictionary: string,
        _svg: string,
        overrides?: Overrides & { from?: string | Promise<string> }
    ): Promise<Enoji> {
        return super.deploy(
            _n,
            _priceInWei,
            _dictionary,
            _svg,
            overrides || {}
        ) as Promise<Enoji>
    }
    getDeployTransaction(
        _n: string,
        _priceInWei: BigNumberish,
        _dictionary: string,
        _svg: string,
        overrides?: Overrides & { from?: string | Promise<string> }
    ): TransactionRequest {
        return super.getDeployTransaction(
            _n,
            _priceInWei,
            _dictionary,
            _svg,
            overrides || {}
        )
    }
    attach(address: string): Enoji {
        return super.attach(address) as Enoji
    }
    connect(signer: Signer): Enoji__factory {
        return super.connect(signer) as Enoji__factory
    }
    static connect(
        address: string,
        signerOrProvider: Signer | Provider
    ): Enoji {
        return new Contract(address, _abi, signerOrProvider) as Enoji
    }
}

const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_n",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "_priceInWei",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "_dictionary",
                type: "address"
            },
            {
                internalType: "address",
                name: "_svg",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [],
        name: "MAX_MULTI_MINT_AMOUNT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "MAX_N_TOKEN_ID",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_svg",
                type: "address"
            }
        ],
        name: "addSVG",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "dictionary",
        outputs: [
            {
                internalType: "contract IEnojiDictionary",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "enableOpenMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "getColors",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "getEmojis",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "maxTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "mint",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]"
            }
        ],
        name: "multiMintWithN",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [],
        name: "n",
        outputs: [
            {
                internalType: "contract IN",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "openMintActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "priceInWei",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dictionary",
                type: "address"
            }
        ],
        name: "setDictionary",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        name: "svgVersions",
        outputs: [
            {
                internalType: "contract IEnojiSVG",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            }
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "tokenSVG",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256"
            }
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "withdrawAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
]

const _bytecode =
    "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"
